<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="0"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>

    <v-layout>
      <v-flex>
        <v-card>
          <v-tabs
            v-model="selectedTab"
            class="no-border-tabs"
          >

            <v-tab value="1" key="LoanSummary">Loan Requests Summary</v-tab>
            <v-tab value="2" key="loanRequests">All Loan Requests</v-tab>
            <v-tab value="3" key="disbursedLoans">Disbursed Loans</v-tab>

          </v-tabs>

          <v-tabs-items v-model="selectedTab">

            <v-tab-item key="LoanSummary">
              <loansummary/>
            </v-tab-item>
            <v-tab-item key="loanRequests">
              <loanRequests/>
            </v-tab-item>
            <v-tab-item key="disbursedLoans">
              <DisbursedLoans/>
            </v-tab-item>

          </v-tabs-items>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import loanRequests from '@/components/views/loan/LoanRequests.vue'
import loansummary from '@/components/views/loan/loansummary.vue'
import DisbursedLoans from '@/components/views/loan/DisbursedLoans.vue'

export default {
	name: 'view_loan_requests',
	components: {
		DisbursedLoans,
		loansummary,
		loanRequests
	},

	data: function () {
		return {
			selectedTab: null,
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: ''

		}
	}

}

</script>
<style scoped>
</style>
